import Branded from "gatsby-theme-nurofen/src/components/common/Branded/Branded"

import "./BrandedOverride.scss"

export default Branded
